import Button from "components/Button";
import InfoCard from "components/InfoCard";
import styles from "../styles.module.scss";

type Props = {
  onClose?: () => void;
  onConfirm?: () => void;
  isLoading?: boolean;
};

const ModalRemoveDeviceContent = ({ onClose, onConfirm, isLoading }: Props) => {
  const handleDelete = () => {
    onConfirm?.();
  };

  const handleCancel = () => {
    onClose?.();
  };

  return (
    <div className={styles.content}>
      <p className={styles.description}>This action cannot be undone</p>

      <InfoCard color="red" variant="red" size="small" className={styles.contentWarning}>
        <p className={styles.contentWarningTitle}>Warning</p>

        <span className={styles.contentWarningText}>
          Are you sure you want to delete this device? All historical data and readings associated with this device will
          be permanently removed.
        </span>
      </InfoCard>

      <div className={styles.buttons}>
        <Button variant="secondary" onClick={handleCancel} disabled={isLoading}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ModalRemoveDeviceContent;
